var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { addFromUrl, addParamsToUrl } from '@zapier/url-utils';
import { GET_HELP_PATH } from '@zapier/product-get-help/esm/constants';
import encodeErrorBundle from '@zapier/product-get-help/esm/utils/encodeErrorBundle';
export const buildGetHelpPath = (_a = {}) => {
    var { zap, error } = _a, passed = __rest(_a, ["zap", "error"]);
    const params = Object.assign({}, passed);
    if (error) {
        params.error = typeof error === 'string' ? error : encodeErrorBundle(error);
    }
    const path = addParamsToUrl(zap ? `${GET_HELP_PATH}/zap/${zap}` : GET_HELP_PATH, params, true);
    return typeof window === 'undefined'
        ? path
        : addFromUrl(path, window.location.href);
};
export default buildGetHelpPath;
